import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getWindowHeight } from "util/isAppRunningInIframe";

export const useStyles = makeStyles((theme: Theme) => {
  const windowHeight: string = getWindowHeight();
  return {
    wrapper: {
      height: windowHeight,
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.palette.primary.main,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: 250,
      marginTop: -100,
    },
    inputField: {
      width: "100%",
      marginBottom: theme.spacing(1.5),
      backgroundColor: "white",
      borderRadius: 4,
      padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    logo: {
      position: "relative",
      left: 30,
      width: 400,
      alignSelf: "center",
      marginBottom: theme.spacing(5),
    },
    button: {
      width: 120,
      backgroundColor: theme.palette.info.main,
      color: "white",
      marginTop: theme.spacing(1),
      "&:hover": {
        backgroundColor: theme.palette.info.dark,
      },
      "&:disabled": {
        backgroundColor: theme.palette.primary.light,
      },
    },
    errorMessage: {
      marginTop: theme.spacing(2),
    },
    successMessage: {
      marginTop: theme.spacing(2),
      color: "white",
    },
    label: {
      color: "white",
      marginBottom: theme.spacing(0.5),
      display: "block",
    },
    backLink: {
      marginTop: theme.spacing(2),
      textDecoration: "none",
      color: "rgba(255,255,255,0.8)",
      "&:hover": {
        color: "rgba(255,255,255,1)",
      },
    },
  };
});
